import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Tree/TreeUsage.mdx";

import Examples from "../../Docs/Components/Tree/TreeExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Tree"
            description="Tree can be used to display a hierarchical data set in an easy to scan way."
            apiSources={["azure-devops-ui/Components/TreeEx/Tree.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;